// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  staging: false,
  // websocket_host: 'wss://eldib-api-prod.herokuapp.com/ws/',
  // backend_host: 'https://eldib-api-prod.herokuapp.com',
  backend_host: 'http://158.69.112.222:8000',
  websocket_host: 'http://158.69.112.222:8000/ws/',
  firebase: {
    apiKey: 'AIzaSyAjAh2k-aWdFHRu0FHR3M9VDgldj9bX8hI',
    authDomain: 'eldib-5d6e4.firebaseapp.com',
    projectId: 'eldib-5d6e4',
    storageBucket: 'eldib-5d6e4.appspot.com',
    messagingSenderId: '952136997477',
    appId: '1:952136997477:web:a1ef16ea7d03c2c66a848c'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
